export const SIGN_IN_PATH = '/sign-in'
